<template>
  <div>
    <h2>{{ messages.coverage_change_request_modal_title }}</h2>
    <p>{{ messages.coverage_change_request_modal_description }}</p>

    <date-input-fragment
      key="startDate"
      :minDate="today"
      :label="messages.coverage_change_request_modal_start_date_label"
      v-model="form.startDate"
      :is-invalid="isFieldInvalid($v.form.startDate)"
    >
      <template #result>
        <p v-if="isFieldInvalid($v.form.startDate)"
           class="error">
          {{ messages.validations_field_required }}
        </p>
      </template>
    </date-input-fragment>

    <fragment-separator />

    <div class="button-group">
      <a class="btn btn-primary-inverse" @click.prevent="closeModal">{{
        messages.coverage_change_request_modal_button_cancel
      }}</a>
      <input
        type="button"
        class="btn btn-primary"
        @click.prevent="submitClicked"
        :disabled="submitting"
        :value="messages.coverage_change_request_modal_button_submit"
      />
    </div>
  </div>
</template>

<script>
import { Mixins } from "@bvm/core";
import * as Api from "./coverage-change-request-form.api";
import { required } from "vuelidate/lib/validators";
import { DateInputFragment, FragmentSeparator } from "@bvm/forms";

const SUCCESS_PAGE_URL = "/page/Coverage%20Change%20Request%20Success";

export default {
  name: "coverage-change-request-form-modal",
  mixins: [Mixins.Lang],
  components: {
    FragmentSeparator,
    DateInputFragment
  },
  props: {
    insuredVehicleId: Number,
    coverageCodes: Array
  },
  data() {
    return {
      messageKeys: [
        "coverage_change_request_modal_title",
        "coverage_change_request_modal_description",
        "coverage_change_request_modal_button_cancel",
        "coverage_change_request_modal_button_submit",
        "coverage_change_request_modal_failed_notification",
        "coverage_change_request_modal_start_date_label",
        "validations_field_required"
      ],
      today: new Date().toISOString().slice(0, 10),
      form: {
        startDate: null
      },
      submitting: false
    };
  },
  validations() {
    return {
      form: {
        startDate: { required }
      }
    };
  },
  methods: {
    isFieldInvalid(field) {
      return field.$dirty && field.$invalid;
    },
    closeModal() {
      // Using 'close' instead of 'dismiss-modal' because current release branch 1-19 does not have the changes from develop.
      // Will be solved after merge with BOP-???
      this.$emit("close");
    },
    submitClicked() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.submitting = true;

      Api.newCoverageChangeRequest(
        this.insuredVehicleId,
        this.coverageCodes,
        this.form.startDate
      )
        .then(() => (window.location.href = SUCCESS_PAGE_URL))
        .catch(error =>
          Bovemij.notifyFailure(
            error,
            this.messages.coverage_change_request_modal_failed_notification
          )
        )
        .finally(() => {
          this.submitting = false;
          this.closeModal();
        });
    }
  }
};
</script>

<style lang="scss">
/* Temp styling because current release branch 1-19 does not support modal classes as property of modal-root-component
       Will be solved after merge with BOP-???
     */
@media (min-width: 576px) {
  .modal .modal-dialog {
    max-width: 520px;
  }
}
</style>
